// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__16BwF","log":"ModalInventoryLogs_log__s-nw8","date":"ModalInventoryLogs_date__1BL32","userName":"ModalInventoryLogs_userName__FfX_w"};